import axios from 'axios';
import useCookies from './useCookies';
import useSentryEvent from './useSentryEvent';

export const useBookingEvent = () => {
  const { getCookie, getCookies } = useCookies();
  const { sendSentryEvent } = useSentryEvent();

  const getPixelCookies = () => {
    return getCookies([
      '_fbc',
      '_fbp',
      'user_agent',
      'handl_ip',
      'gclid',
      'handl_url',
      'handlID',
      'first_handlID',
      'handlID_ref',
      'utm_cart',
      'fb_pixel_id',
    ]);
  };

  const fireClientEvent = (email, event, value, eventId) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        try {
          const handl_event_id = getCookie('first_handlID');
          console.log(
            'Firing Client Side Booking event for handl_event_id: ',
            handl_event_id
          );

          sendSentryEvent(`Firing Client Side Booking event ${email}`);
          // if (handl_event_id) {
          //   window.HandL.sendFBEvent(
          //     event,
          //     { value: value, currency: 'USD' },
          //     { eventID: eventId + handl_event_id }
          //   );
          // } else {
          //   window.HandL.sendFBEvent(event, {
          //     value: value,
          //     currency: 'USD',
          //   });
          // }
          sendSentryEvent(`Firing Client Side Booking event success ${email}`);
          console.log('Firing Client Side Booking event success', email);
          resolve(true);
        } catch (error) {
          console.log(`Error Firing Client Side Booking event ${email}`, error);
          sendSentryEvent(`Error Firing Client Side Booking event ${email}`);
          resolve(false);
        }
      }, 1000);
    });
  };

  const getBookingData = async (email) => {
    try {
      const bookingConfigResult = await axios({
        url: `https://api.pompaprogram.com/get-booking-event?email=${email}`,
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return bookingConfigResult.data;
    } catch (error) {
      console.log('Error getting booking config:', error);
      sendSentryEvent(`Error getting booking config ${email}`);
      throw error;
    }
  };

  const handleBookingEvent = async (
    email,
    event = 'Schedule',
    value = 120,
    eventId = 'pp_scp_'
  ) => {
    try {
      const bookingData = await getBookingData(email);
      console.log('bookingData', bookingData.bookingEvent);

      if (!bookingData.bookingEvent) {
        const clientEventResult = await fireClientEvent(
          email,
          event,
          value,
          eventId
        );
        if (clientEventResult) {
          const config = {
            url: 'https://api.pompaprogram.com/set-booking-event',
            method: 'post',
            data: {
              email: email,
              ...getPixelCookies(),
            },
            headers: {
              'Content-Type': 'application/json',
            },
          };

          await axios(config);
          console.log('Server Side Booking event fired');
          return true;
        }
      }
      return false;
    } catch (error) {
      console.log('Error setting server side booking event:', error);
      sendSentryEvent(`Error setting server side booking event ${email}`);
      return false;
    }
  };

  const handleScheduleEvent = async (email) => {
    return handleBookingEvent(email, 'Schedule', 120, 'pp_scp_');
  };

  return {
    fireClientEvent,
    getPixelCookies,
    handleBookingEvent,
    handleScheduleEvent,
  };
};

export default useBookingEvent;
